export default "<div class=\"loader-dots\">\n  <div></div>\n  <div></div>\n  <div></div>\n  <div></div>\n</div>\n"